/**
 * Added to doors on frames directly next to corner solutions to signal that it's not possible to
 * to change opening direction (handled automatically by DoorNextToCornerSolutionSystem)
 */
class DoorsNextToCornerSolutionComponent {
    constructor() {
        this.typeId = DoorsNextToCornerSolutionComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
DoorsNextToCornerSolutionComponent.id = 2039;
export default DoorsNextToCornerSolutionComponent;
//# sourceMappingURL=DoorNextToCornerSolutionComponent.js.map